import { render, staticRenderFns } from "./GlobalRides.vue?vue&type=template&id=12b070b8&scoped=true&"
import script from "./GlobalRides.vue?vue&type=script&lang=js&"
export * from "./GlobalRides.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRides.vue?vue&type=style&index=0&id=12b070b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b070b8",
  null
  
)

export default component.exports